// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"DashboardLayout_dashboardContainer__ua9hs"};